import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import { InputGroup, DropdownButton, MenuItem } from 'react-bootstrap';
import {
  find, reduce, without, concat, indexOf, delay, compact,
  throttle, first,
} from 'lodash';
import Fa from 'react-fontawesome';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { parallel } from 'async';

import masterField from './master-field';
import Avatar from '../avatar';
import styles from './styles.css';
import { getSearchFilters } from './search-form-reducer';

const options = [
  { value: 'equals', label: 'Equals' },
  { value: 'contains', label: 'Contains' },
  { value: 'startsWith', label: 'Starts with' },
  { value: 'endsWith', label: 'Ends with' },
];


function escapeRegexCharacters(str) {
  // return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return str;
}

function blurAll(parent = document.body) {
  const tmp = document.createElement('input');
  tmp.className = styles.hiddenInput;
  parent.appendChild(tmp);
  delay(() => {
    tmp.focus();
    parent.removeChild(tmp);
  }, 1);
}
const FadeAnimation = ({ children, ...props }) => (
  <CSSTransition
    {...props}
  >
    {children}
  </CSSTransition>
);
FadeAnimation.propTypes = {
  children: PropTypes.element,
};
FadeAnimation.defaultProps = {
  children: null,
};

class DropDownField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      loading: false,
      loadingValues: false,
      focus: false,
      suggestions: [],
    };
    this.onChange = this.onChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onSuggestionsFetchRequested = throttle(this.onSuggestionsFetchRequested, 500, { leading: false }).bind(this);
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    this.getSuggestionValue = this.getSuggestionValue.bind(this);
    this.getSectionSuggestions = this.getSectionSuggestions.bind(this);
    this.removeTag = this.removeTag.bind(this);
    this.renderSuggestion = this.renderSuggestion.bind(this);
    this.renderSectionTitle = this.renderSectionTitle.bind(this);
    this.renderSuggestionsContainer = this.renderSuggestionsContainer.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onChangeType = this.onChangeType.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }
  
  onChangeType(controlType) {
    const { path, searchCriteria } = this.props;
    this.props.onUpdate(path, { values: searchCriteria.values, control_type: controlType });
  }

  onChange(event, { newValue }) {
    this.setState({
      value: newValue,
    });
  }

  onFocus() {
    this.setState({ focus: true });
  }

  onBlur() {
    this.setState({ focus: false });
  }

  onKeyUp(event) {
    if (event.keyCode === 13) {
      if (event.target.value && event.target.value.length) {
        this.onSuggestionSelected(event, { suggestion: { value: escapeRegexCharacters(event.target.value.trim()) } }, true);
      }
    }
  }

  // Autosuggest will call this function every time
  // you need to update suggestions.
  onSuggestionsFetchRequested({ value }) {
    this.setState({ loading: true, suggestions: [] });
    const { searchCriteria } = this.props;
    const escapedValue = escapeRegexCharacters(value.trim());

    const p = new Promise((resolve, reject) => {
      parallel(
        [
          (callback) => {
            if (escapedValue && escapedValue.length) {
              const currentValues = searchCriteria.values || [];
                const exist = indexOf(currentValues, escapedValue) >= 0;
                if (!exist) {
                  callback(null, {
                    suggestions: [{
                      tagType: 'value',
                      _id: escapedValue,
                      value: escapedValue,
                      label: escapedValue,
                      name: escapedValue,
                      isId: true,
                    }],
                  });
                } else {
                  callback(null, {
                    suggestions: [],
                  });
                }
            } else {
              callback(null, {
                suggestions: [],
              });
            }
          },
        ],
        (error, results) => {
          if (error) {
            reject(error);
          } else {
            resolve(compact(results));
          }
        },
      );
    });

    p.then(
      (suggestions) => {
        this.setState({ suggestions, loading: false });
      },
      () => {
        this.setState({ suggestions: [], loading: false });
      },
    );
    return p;
  }

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested() {
    this.setState({ suggestions: [] });
  }

  onSuggestionSelected(event, { suggestion }, checkDuplication = false) {
    if (!suggestion.isEmpty && !suggestion.isHeader) {
      const { searchCriteria, path } = this.props;
      const values = searchCriteria.values || [];
      const { value } = suggestion;
      const exist = indexOf(values, value) >= 0;
      const newValues = exist ? without(values, checkDuplication ? '' : value) : concat(values, value);
      this.props.onUpdate(path, { values: newValues });
    }
    this.setState({ value: '' });
    blurAll(this.element);
  }


  getSuggestionValue(suggestion) {
    if (suggestion.isHeader || suggestion.isEmpty) {
      return '';
    }
    return suggestion.label;
  }

  getSectionSuggestions(section) {
    return section.suggestions;
  }

  removeTag(suggestion) {
    const { searchCriteria, path } = this.props;
    if (suggestion.tagType === 'mapping') {
      const mappings = searchCriteria.mappings || [];
      const newMappings = without(mappings, suggestion._id);
      this.props.onUpdate(path, { mappings: newMappings });
    } else {
      const values = searchCriteria.values || [];
      const newValues = without(values, suggestion.value);
      this.props.onUpdate(path, { values: newValues });
    }
  }

  renderSuggestion(suggestion, { query }) {
    const { label } = suggestion;
    if (suggestion.isEmpty) {
      return (
        <a href="" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }} style={{ cursor: 'not-allowed' }}>
          <em className="text-muted">{suggestion.label}</em>
        </a>
      );
    }
    const matches = match(label, query);
    const parts = parse(label, matches).map((part, id) => ({ ...part, id }));

    return (
      <a href="" onClick={(e) => { e.preventDefault(); }}>
        <span className={suggestion.isId ? styles.idTag : ''}>
          {parts.map((part) => {
            const className = part.highlight ? styles.tagHighlight : null;
            return (
              <span className={className} key={part.id}>
                {part.text}
              </span>
            );
          })}
        </span>
      </a>
    );
  }

  renderSuggestionsContainer({ containerProps, children }) {
    if (this.props.dropdownRef && this.element) {
      const bounds = this.element.getBoundingClientRect();
      const containerBounds = this.props.dropdownRef.getBoundingClientRect();

      const { height, left, top } = bounds;
      const elY = top + document.documentElement.scrollTop;
      const elX = left + document.documentElement.scrollLeft;
      
      const containerX = containerBounds.left + document.documentElement.scrollLeft;
      const containerY = containerBounds.top + document.documentElement.scrollTop;

      const y = elY - containerY;
      const x = elX - containerX;


      const inner = (
        <div {...containerProps} style={{ top: (y + height), left: x }}>
          {children}
        </div>
      );

      return ReactDOM.createPortal(
        inner,
        this.props.dropdownRef,
      );
    }
    return (
      <div {...containerProps}>
        {children}
      </div>
    );
  }

  renderSectionTitle(section) {
    return section.title ? `${section.title}:` : null;
  }

  render() {
    const {
      value, suggestions, focus, loading,
    } = this.state;
    const {
      disabled, searchCriteria, searchFilter, readOnly,
    } = this.props;
    if (!searchFilter) {
      return null;
    }
    const inputProps = {
      placeholder: 'enter keyword...',
      value,
      className: styles.tagInput,
      onChange: this.onChange,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onKeyUp: this.onKeyUp,
      disabled,
    };
    const theme = {
      container: styles.autocomplete,
      suggestionsContainer: `dropdown open ${styles.suggestionsContainer}`,
      sectionContainer: `dropdown-menu ${styles.sectionContainer}`,
      suggestionsList: `dropdown-menu ${styles.suggestionsList}`,
      sectionTitle: 'dropdown-header',
      suggestion: '',
      suggestionFocused: 'active',
    };

    const tags = reduce(searchCriteria.values, (items, val) => {
      items.push({
        _id: val, value: val, label: val, tagType: 'value',
      });
      return items;
    }, []);

    const hasMore = true;
    // const isUser = searchFilter.$is_user_mapping;
    const cls = [styles.tagInputField, styles.stringField];
    if (focus) {
      cls.push(styles.tagInputFieldFocus);
    }
    const currentControlType = searchCriteria.control_type;
    const activeControl = find(options, { value: currentControlType }) || first(options);

    return (
      <div className="clearfix">
        <div className="">
          <DropdownButton
            componentClass={InputGroup.Button}
            id={searchCriteria.filter_id}
            title={activeControl ? activeControl.label : 'Select'}
            bsStyle="link"
            bsSize="xs"
            disabled={(disabled || readOnly)}
            onSelect={this.onChangeType}
          >
            {options.map((option) => {
              return (
                <MenuItem active={activeControl && activeControl.value === option.value} key={option.value} eventKey={option.value}>{option.label}</MenuItem>
              );
            })}
          </DropdownButton>
        </div>
        <div className="">
          <div
            className={`${cls.join(' ')}`}
          >
            <TransitionGroup className={styles.tagList}>
              {tags.map((tag) => {
                const isUserTag = tag.user_id !== undefined && tag.user_id !== null;

                const tCls = [styles.tag, styles.valueTag, styles.keywordTag];
                
                if (disabled) {
                  tCls.push(styles.disabledTag);
                }
                if (readOnly) {
                  tCls.push(styles.readOnlyTag);
                }
                return (
                  <FadeAnimation
                    classNames="tag"
                    timeout={500}
                    key={tag.tagType === 'mapping' ? tag._id : tag.value}
                  >
                    <span className={`${tCls.join(' ')}`}>
                      {isUserTag && <Avatar small user={tag} />}
                      <span className={styles.tagLabel}>{tag.label}</span>
                      {!readOnly &&
                        <a
                          href=""
                          className={styles.tagTrash}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (!disabled) {
                              this.removeTag(tag);
                            }
                          }}
                        >
                          <Fa name="times" />
                        </a>
                      }
                    </span>
                  </FadeAnimation>
                );
              })}
              {hasMore && !disabled &&
                <FadeAnimation
                  classNames="tag"
                  timeout={500}
                >
                  <div ref={(el) => { this.element = el; }} className={styles.autocompleteWrapper}>
                    <Autosuggest
                      theme={theme}
                      suggestions={suggestions}
                      multiSection
                      renderSectionTitle={this.renderSectionTitle}
                      getSectionSuggestions={this.getSectionSuggestions}
                      onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                      shouldRenderSuggestions={() => true}
                      onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                      onSuggestionSelected={this.onSuggestionSelected}
                      getSuggestionValue={this.getSuggestionValue}
                      renderSuggestion={this.renderSuggestion}
                      renderSuggestionsContainer={this.renderSuggestionsContainer}
                      inputProps={inputProps}
                      ref={(input) => { this.fieldEl = input; }}
                    />
                    <Fa name="spinner" spin className={styles.spinner} />
                  </div>
                </FadeAnimation>
              }
            </TransitionGroup>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state, props) {
  const { searchCriteria, searchType } = props;
  const { filter } = searchCriteria;
  // const isOpportunityId = targetObject === 'Opportunity' && filter.target_field === 'Id';
  const isOpportunityId = filter.$is_opportunity_id

  const searchFilter = find(getSearchFilters(searchType, state), { _id: filter._id })
  return {
    isOpportunityId,
    searchFilter,
  };
}

DropDownField.propTypes = {
  dispatch: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  path: PropTypes.arrayOf(PropTypes.string).isRequired,
  searchType: PropTypes.string.isRequired,
  searchFilter: PropTypes.shape({}).isRequired,
  searchCriteria: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    mappings: PropTypes.array,
    values: PropTypes.array,
    filter: PropTypes.shape({
      _id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  }),
  onUpdate: PropTypes.func.isRequired,
  isOpportunityId: PropTypes.bool,
  dropdownRef: PropTypes.oneOfType([
    // Either a function
    PropTypes.func,
    // Or the instance of a DOM native element (see the note about SSR)
    PropTypes.shape({ current: PropTypes.elementType }),
  ]),
};

DropDownField.defaultProps = {
  searchCriteria: null,
  disabled: false,
  isOpportunityId: false,
  dropdownRef: null,
};


export default masterField(connect(mapStateToProps)(DropDownField));
